(function () {
  function getHeaderOffset() {
    const root = document.documentElement;
    const live = getComputedStyle(root).getPropertyValue('--header-height-live').trim();
    const base = getComputedStyle(root).getPropertyValue('--header-height').trim();
    const value = parseFloat(live) || parseFloat(base) || 0;
    return Number.isFinite(value) ? value : 0;
  }

  function scrollToTarget(selector) {
    if (!selector) return;
    const target = document.querySelector(selector);
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 2;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function pauseVideos(root) {
    root.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (e) {}
    });
  }

  function playVideo(video) {
    if (!video) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function syncIntroMedia(root) {
    if (!root) return;
    var mobile = isMobileViewport();
    var desktopLayer = root.querySelector('[data-intro-media="desktop"]');
    var mobileLayer = root.querySelector('[data-intro-media="mobile"]');
    var activeLayer = mobile ? mobileLayer : desktopLayer;
    var idleLayer = mobile ? desktopLayer : mobileLayer;

    pauseVideos(root);

    if (idleLayer) {
      idleLayer.querySelectorAll('video').forEach(function (video) {
        try {
          video.removeAttribute('autoplay');
          video.preload = 'none';
        } catch (e) {}
      });
    }

    if (activeLayer) {
      var video = activeLayer.querySelector('video');
      if (video) {
        try {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.preload = mobile ? 'metadata' : 'auto';
        } catch (e) {}
        playVideo(video);
      }
    }
  }

  function bindIntro(root) {
    if (!root || root.dataset.scenarioIntroBound === 'true') return;
    root.dataset.scenarioIntroBound = 'true';

    root.querySelectorAll('[data-scenario-intro-scroll]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        var href = el.getAttribute('href');
        var selector = el.getAttribute('data-scenario-intro-scroll') || href;
        if (!selector || selector.charAt(0) !== '#') return;
        event.preventDefault();
        scrollToTarget(selector);
      });
    });

    syncIntroMedia(root);

    if (!root._scenarioIntroMediaMq) {
      root._scenarioIntroMediaMq = window.matchMedia('(max-width: 749px)');
      var onChange = function () {
        syncIntroMedia(root);
      };
      if (typeof root._scenarioIntroMediaMq.addEventListener === 'function') {
        root._scenarioIntroMediaMq.addEventListener('change', onChange);
      } else if (typeof root._scenarioIntroMediaMq.addListener === 'function') {
        root._scenarioIntroMediaMq.addListener(onChange);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-scenario-intro]').forEach(bindIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-scenario-intro]') ||
      event.target.closest('[data-scenario-intro]');
    if (root) {
      root.dataset.scenarioIntroBound = 'false';
      bindIntro(root);
    }
  });
})();
